import './_product-shipping-callout.scss';

export default () => {};
